// Derivations start on GLOBAL_START_EPOCH so they are dirty before having been computed
export const GLOBAL_START_EPOCH = -1
